import React from "react";
import {Tooltip} from 'react-tooltip';

const MapTooltip = ({id}) => {
    return (
        <>
            <Tooltip
               id={id}
               backgroundColor="#322a6f"
               color="#f5ab18"
               place="bottom"
               fontWeight="bold"
               arrowColor="transparent"
               style={{
                   position: "absolute",
                   display: "inline-block",
                   padding: "0 8px",
                   borderRadius: "5px",
                   border: "2px solid #322a6f",
                   fontSize: "18px",
                   lineHeight: "30px",
                   textAlign: "center",
                   fontWeight: "bold",
                   color: "#f5ab18",
                   background: "#322a6f",
                   zIndex: 999,
               }}
            />
        </>
    );
};

export default MapTooltip;
